import {
    useState,
    useEffect,
    useContext,
    createContext
} from 'react'
import {
    useMediaQuery,
    useTheme
} from '@mui/material'

const Context = createContext()

export default function Provider({ children }) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const isLandscape = useMediaQuery('(orientation: landscape) and (max-height: 600px)')

    const [open, setOpen] = useState(!isMobile)
    const [title, setTitle] = useState('')

    useEffect(() => {
        document.title = title ? `MZ | ${title}` : 'MZ'
    }, [title])

    return (
        <Context.Provider value={{
            open, setOpen,
            title, setTitle,
            isLandscape
        }}>
            {children}
        </Context.Provider>
    )
}

export const useDashboard = () => useContext(Context)